import { Pipe, PipeTransform } from '@angular/core';
import { BreakpointAvailable } from '@services/responsive';
import { Title } from '@shared/components/title/model';

@Pipe({
  name: 'fontSize',
  standalone: true,
})
export class FontSizePipe implements PipeTransform {
  transform(title: Title, breakpoint: BreakpointAvailable): string | null {
    if (breakpoint === 'desktop') {
      return title?.size?.custom?.desktop ?? null;
    }
    return title?.size?.custom?.mobile ?? null;
  }
}
